
import React from "react";
import styles from "../Dashoard.module.css";
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';





const LearnersTBD = () => {


  const learnersTBDData = [
    {
      label: "New York",
      amount: "$10,240",
      downstatus: true,
    },

    {
      label: "Los Angeles",
      amount: "$10,240",
      upstatus: true,
    },
    {
      label: "Texas",
      amount: "$2,590",
      upstatus: true,
    },
  ]

  return (
    <div className={styles.StatusSection}>

      {/* <div className={styles.StatusSectionHeader}>
        <h2>LearnersTBD</h2>
      </div> */}

      {/* {learnersTBDData?.map((item, i) => (
        <div className={styles.StatusTableListing}>
          <div className={styles.StatusTableListingLabel}>{item.label}</div>
          <div className={styles.StatusTableListingEntry}>
            {item.upstatus &&
              <div className={styles.StatusCardChip}>
                <span className={styles.StatusCardChipGreen}><ArrowUpwardIcon /></span>
              </div>
            }

            {item.downstatus &&
              <div className={styles.StatusCardChip}>
                <span className={styles.StatusCardChipRed}><ArrowDownwardIcon /></span>
              </div>
            }
            {item.amount}
          </div>
        </div>
      ))} */}
    </div>
  );
};

export default LearnersTBD;

